import { Alert, type AlertProps, cn } from "@kyan/ui";

import type { LiquidationWarningVariant } from "#/store/app/liquidationWarnings/liquidationWarnings.types";
import { type UnderlyingSymbol } from "#/types/markets";

import {
  createDescription,
  createTitle,
} from "../../LiquidationWarnings.utils";

export interface LiquidationAlertProps extends Omit<
  AlertProps,
  "variant" | "title" | "description"
> {
  symbol: UnderlyingSymbol;
  variant: LiquidationWarningVariant;
  mmr?: number;
}
export const LiquidationAlert: React.FC<LiquidationAlertProps> = ({
  mmr,
  symbol,
  variant,
  className,
  closeIconProps,
  actionProps,
  ...props
}) => {
  const isWarning = variant === "warning";

  return (
    <Alert
      className={cn("p-4", className)}
      title={createTitle(symbol, variant)}
      variant={isWarning ? "warning" : "error"}
      description={createDescription({ symbol, variant, mmr })}
      closeIconProps={{
        size: "sm",
        ...closeIconProps,
      }}
      actionProps={{
        size: "md",
        children: "Deposit",
        variant: "alternative",
        className: "text-sm w-26",
        ...actionProps,
      }}
      {...props}
    />
  );
};
